export const ANALYTICS_PATH = '/analytics' as const;
export const ROOT = {
  PATH: ANALYTICS_PATH,
  toPath: () => ANALYTICS_PATH,
};
